import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public endpoints
export const getPortfolio = () => api.get('/portfolio');
export const getFeaturedPortfolio = () => api.get('/portfolio/featured');
export const getTestimonials = () => api.get('/testimonials');
export const getSettings = () => api.get('/settings');
export const createBooking = (data) => api.post('/bookings', data);
export const createPaymentSession = (bookingId) => api.post(`/payments/create-session?booking_id=${bookingId}`);
export const verifyPayment = (bookingId) => api.get(`/payments/verify?booking_id=${bookingId}`);
export const submitReview = (data) => api.post('/testimonials', data);
export const seedData = () => api.post('/seed');

// Admin auth
export const adminLogin = (credentials) => api.post('/admin/login', credentials);
export const adminLogout = () => api.post('/admin/logout');
export const verifyAdmin = () => api.get('/admin/verify');

// Admin bookings
export const getBookings = () => api.get('/admin/bookings');
export const getBooking = (id) => api.get(`/admin/bookings/${id}`);
export const updateBooking = (id, data) => api.patch(`/admin/bookings/${id}`, data);
export const deleteBooking = (id) => api.delete(`/admin/bookings/${id}`);

// Admin portfolio
export const createPortfolioItem = (data) => api.post('/admin/portfolio', data);
export const updatePortfolioItem = (id, data) => api.patch(`/admin/portfolio/${id}`, data);
export const deletePortfolioItem = (id) => api.delete(`/admin/portfolio/${id}`);

// Admin testimonials
export const createTestimonial = (data) => api.post('/admin/testimonials', data);
export const updateTestimonial = (id, data) => api.patch(`/admin/testimonials/${id}`, data);
export const deleteTestimonial = (id) => api.delete(`/admin/testimonials/${id}`);

// Admin settings
export const updateSettings = (data) => api.patch('/admin/settings', data);

export default api;
